export const states = [
  {
    name: 'Delaware',
    isoCode: 'DE',
  },
  {
    name: 'District of Columbia',
    isoCode: 'DC',
  },
  {
    name: 'Alaska',
    isoCode: 'AK',
  },
  {
    name: 'Maryland',
    isoCode: 'MD',
  },
  {
    name: 'New Hampshire',
    isoCode: 'NH',
  },
  {
    name: 'Kansas',
    isoCode: 'KS',
  },
  {
    name: 'Texas',
    isoCode: 'TX',
  },
  {
    name: 'Nebraska',
    isoCode: 'NE',
  },
  {
    name: 'Vermont',
    isoCode: 'VT',
  },
  {
    name: 'Hawaii',
    isoCode: 'HI',
  },
  {
    name: 'Utah',
    isoCode: 'UT',
  },
  {
    name: 'Oregon',
    isoCode: 'OR',
  },
  {
    name: 'California',
    isoCode: 'CA',
  },
  {
    name: 'New Jersey',
    isoCode: 'NJ',
  },
  {
    name: 'North Dakota',
    isoCode: 'ND',
  },
  {
    name: 'Kentucky',
    isoCode: 'KY',
  },
  {
    name: 'Minnesota',
    isoCode: 'MN',
  },
  {
    name: 'Oklahoma',
    isoCode: 'OK',
  },
  {
    name: 'Pennsylvania',
    isoCode: 'PA',
  },
  {
    name: 'New Mexico',
    isoCode: 'NM',
  },
  {
    name: 'Illinois',
    isoCode: 'IL',
  },
  {
    name: 'Michigan',
    isoCode: 'MI',
  },
  {
    name: 'Virginia',
    isoCode: 'VA',
  },
  {
    name: 'West Virginia',
    isoCode: 'WV',
  },
  {
    name: 'Mississippi',
    isoCode: 'MS',
  },
  {
    name: 'Massachusetts',
    isoCode: 'MA',
  },
  {
    name: 'Arizona',
    isoCode: 'AZ',
  },
  {
    name: 'Connecticut',
    isoCode: 'CT',
  },
  {
    name: 'Florida',
    isoCode: 'FL',
  },
  {
    name: 'Indiana',
    isoCode: 'IN',
  },
  {
    name: 'Wisconsin',
    isoCode: 'WI',
  },
  {
    name: 'Wyoming',
    isoCode: 'WY',
  },
  {
    name: 'South Carolina',
    isoCode: 'SC',
  },
  {
    name: 'Arkansas',
    isoCode: 'AR',
  },
  {
    name: 'South Dakota',
    isoCode: 'SD',
  },
  {
    name: 'Montana',
    isoCode: 'MT',
  },
  {
    name: 'North Carolina',
    isoCode: 'NC',
  },
  {
    name: 'Colorado',
    isoCode: 'CO',
  },
  {
    name: 'Missouri',
    isoCode: 'MO',
  },
  {
    name: 'New York',
    isoCode: 'NY',
  },
  {
    name: 'Maine',
    isoCode: 'ME',
  },
  {
    name: 'Tennessee',
    isoCode: 'TN',
  },
  {
    name: 'Georgia',
    isoCode: 'GA',
  },
  {
    name: 'Alabama',
    isoCode: 'AL',
  },
  {
    name: 'Louisiana',
    isoCode: 'LA',
  },
  {
    name: 'Nevada',
    isoCode: 'NV',
  },
  {
    name: 'Iowa',
    isoCode: 'IA',
  },
  {
    name: 'Idaho',
    isoCode: 'ID',
  },
  {
    name: 'Rhode Island',
    isoCode: 'RI',
  },
  {
    name: 'Washington',
    isoCode: 'WA',
  },
  {
    name: 'Ohio',
    isoCode: 'OH',
  },
];
